import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { IconModule, MediaModule } from '@spartacus/storefront';
import { MyAccountLeftSidenavComponent } from './my-account-left-sidenav.component';

@NgModule({
  declarations: [MyAccountLeftSidenavComponent],
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    IconModule,
    I18nModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MediaModule,
    MatExpansionModule,
  ],
  exports: [MyAccountLeftSidenavComponent],
})
export class KbMyAccountLeftSideNavModule { }
